export const chevronUpPath = "<path d=\"M4 10 L8 6 L12 10\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>"
